// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_1iJcwEk","h5Text":"gUz0wqI","h4Text":"Bguvnwe","h3Text":"_1TWbcJB","srOnly":"_2DWU5Zi","link":"_3yAIY6n _1iJcwEk","title":"_234PYvW _1TWbcJB"};